/* eslint-disable no-extend-native */

export async function loadPolyfills() {
  if ('ResizeObserver' in window === false) {
    const module = await import('@juggle/resize-observer');
    (window as any).ResizeObserver = module.ResizeObserver;
  }

  if (!Math.sign) {
    Math.sign = function (x) {
      x = +x; // convert to a number
      if (x === 0 || isNaN(x)) {
        return x;
      }
      return x > 0 ? 1 : -1;
    };
  }

  if (!Array.prototype.toSorted) {
    Array.prototype.toSorted = function (compareFn) {
      if (typeof compareFn !== 'undefined' && typeof compareFn !== 'function') {
        throw new TypeError(
          `The comparison function must be either a function or undefined: ${compareFn}`,
        );
      }

      return [...this].sort(compareFn);
    };
  }
}
